import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Observable, map, of, startWith } from 'rxjs';
import { Country } from 'src/app/core/models/country.model';
import { MyPolicy } from 'src/app/core/models/my-policy.model';
import { TravelPurpose } from 'src/app/core/models/travel-purpose.model';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';
export function dateRangeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const fromDate = control.get('fromDate')?.value;
    const toDate = control.get('toDate')?.value;

    if ((fromDate && !toDate) || (!fromDate && toDate)) {
      return { dateRangeRequired: true };
    }

    return null;
  };
}
@Component({
  selector: 'app-my-policy',
  templateUrl: './my-policy.component.html',
  styleUrls: ['./my-policy.component.scss']
})
export class MyPolicyComponent {
  userDetail: any;
  currentPage: number = 1;
  row_count: number = 1;
  page_count: number = 10;
  totalCount: number = 0;
  resultPerpage = new FormControl(10);
  myPolicyList: MyPolicy[] = [];
  currentDate:any=moment();
  lastSeventDate:any=moment().subtract(7, 'days');
  myPolicyFilters = this.fb.group({
    organizationType: [''],
    organization: [''],
    policyNumber: [''],
    fromDate: [this.lastSeventDate],
    toDate: [this.currentDate],
    travelPurpose: [null],
    destination: [''],
    user: [''],
    branch: ['']
  }, { validators: dateRangeValidator() });
  isLoadingForMyPolicyList = true;
  getTravelPurposeList: TravelPurpose[] = [];
  getCountriesList: Country[] = [];
  destinationFilteredOptions: Observable<Country[]> | undefined;
  getUserList: any[] = [];
  userFilteredOptions: Observable<any[]> | undefined;
  getBranchList: any[] = [];
  branchFilteredOptions: Observable<any[]> | undefined;
  filteredOrganizationTypes: Observable<any[]> | undefined;
  filteredOrganizations: Observable<any[]> | undefined;
  connectedOrganizations:any[]=[];
  organizations:any[]=[];
  hideFields:boolean=false;
   currentLanguage: string = '';
  constructor(
    private fb: FormBuilder,
    private restService: RestService,
    private loader: LoaderService,
    private router: Router,
    private errorHandler: ErrorHandlerService,
     private translate: TranslateService
  ) {
    this.currentLanguage = this.translate.currentLang;
     this.translate.onLangChange.subscribe((event: any) => {
      this.currentLanguage = event.lang;
     })
  }

  ngOnInit() {
    this.getMenuData();
    this.GetMasterData();
    this.FetchConnectedOrganizationsCount();
    this.FetchUsersOrgGroups();
    this.FetchUsersInOrgGroup();
    this.resultPerpage.valueChanges.subscribe(value => {
      this.row_count = 1;
      this.page_count = parseFloat(this.resultPerpage?.value?.toString() ?? '');
      this.currentPage = 1;
      this.GetAllMyPolicy();
    });

    this.myPolicyFilters.get('fromDate')?.valueChanges.subscribe(fromDate => {
      const toDate = this.myPolicyFilters.get('toDate')?.value;
    
      if (fromDate && toDate && moment(fromDate).isAfter(moment(toDate))) {
        this.myPolicyFilters.patchValue({ toDate: null }, { emitEvent: false });
      }
    });
    
    this.myPolicyFilters.get('toDate')?.valueChanges.subscribe(toDate => {
      const fromDate = this.myPolicyFilters.get('fromDate')?.value;

      if (fromDate && toDate && moment(toDate).isBefore(moment(fromDate))) {
        this.myPolicyFilters.patchValue({ fromDate: null }, { emitEvent: false });
      }
    });

    
    this.GetAllMyPolicy();
  }

  private _orgTypeFilter(value: string): Country[] {
    const filterValue = value.toLowerCase();
    return this.connectedOrganizations.filter(option => option.orgGroupRelationshipTypeName.toLowerCase().includes(filterValue));
  }
  private _orgFilter(value: string): Country[] {
    const filterValue = value.toLowerCase();
    return this.organizations.filter(option => option.orgName.toLowerCase().includes(filterValue));
  }


  orgTypeDisplayFn(data: any): string {
    return data && data.orgGroupRelationshipTypeName ? data.orgGroupRelationshipTypeName : '';
  }

  orgDisplayFn(data: any): string {
    return data && data.orgName ? data.orgName : '';
  }

  destinationDisplayFn(user: Country): string {
    return user && user.ToCountryName ? user.ToCountryName : '';
  }

  private _destinationFilter(name: string): Country[] {
    const filterValue = name.toLowerCase();

    return this.getCountriesList.filter(option => option.ToCountryName.toLowerCase().includes(filterValue));
  }

  userDisplayFn(user: any): string {
    return user && user.fullName ? user.fullName : '';
  }

  private _userFilter(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.getUserList.filter(option => option.fullName.toLowerCase().includes(filterValue));
  }
  
  
  branchDisplayFn(branch: any): string {
    return branch && branch.orgGroupName ? branch.orgGroupName : '';
  }

  private _branchFilter(branch: string): any[] {
    const filterValue = branch.toLowerCase();

    return this.getBranchList.filter(option => option.orgGroupName.toLowerCase().includes(filterValue));
  }
  GetMasterData() {
    this.loader.show();

    this.restService.postData({
    "id": this.currentLanguage == 'en' ? '1' : '2', // Assuming 1 is for English and 2 for other languages
}, 'api/Quotation/GetMasterData').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.getTravelPurposeList = data.rObj.GetTravelPurpose || [];
              this.getCountriesList = data.rObj.GetCountries || [];

              this.destinationFilteredOptions = this.myPolicyFilters.get('destination')?.valueChanges.pipe(
                startWith(''),
                map((value:any) => {
                  const name = typeof value === 'string' ? value : value?.ToCountryName;
                  return name ? this._destinationFilter(name as string) : this.getCountriesList.slice();
                }),
              );
             
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }
  goBack() {
    this.router.navigate(['dashboard']);
  }

  GetAllMyPolicy() {
    let selectedDestination:any = this.myPolicyFilters.get('destination')?.value;
    let selectedUser:any = this.myPolicyFilters.get('user')?.value;
    let selectedBranch:any = this.myPolicyFilters.get('branch')?.value;
    let params = {
      PageNo: this.row_count,
      PageSize: this.page_count,
      PolicyNumber: this.myPolicyFilters.get('policyNumber')?.value?.trim() || null,
      FromDate: this.myPolicyFilters.get('fromDate')?.value ? moment(this.myPolicyFilters.get('fromDate')?.value).format('YYYY-MM-DD') : null,
      ToDate: this.myPolicyFilters.get('toDate')?.value ? moment(this.myPolicyFilters.get('toDate')?.value).format('YYYY-MM-DD') : null,
      destinationId:selectedDestination ? selectedDestination?.TocountryID: "00000000-0000-0000-0000-000000000000",
      travelPurposeId:this.myPolicyFilters.get('travelPurpose')?.value || "00000000-0000-0000-0000-000000000000",
      userId:selectedUser?selectedUser?.userID:"00000000-0000-0000-0000-000000000000",
      branchId:selectedBranch?selectedBranch?.orgGroupID:"00000000-0000-0000-0000-000000000000",
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/MyPolicy').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.myPolicyList = data.rObj.MyPolicy || [];
              this.isLoadingForMyPolicyList = false;
              this.totalCount = data.rObj.TotalRecords;
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.isLoadingForMyPolicyList = false;
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  FetchUsersOrgGroups() {
    let params={
      typeCodeNum: '1400'
    }
    this.loader.show();
    this.restService.postDataDs(params, 'api/digital/core/User/FetchUsersOrgGroups').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.getBranchList=data.rObj.fetchUserOrgGroup ||[];
              this.branchFilteredOptions = this.myPolicyFilters.get('branch')?.valueChanges.pipe(
                startWith(''),
                map((value:any) => {
                  const name = typeof value === 'string' ? value : value?.orgGroupName;
                  return name ? this._branchFilter(name as string) : this.getBranchList.slice();
                }),
              );
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  FetchUsersInOrgGroup() {
    let params={};
    this.loader.show();
    this.restService.postDataDs(params, 'api/digital/core/User/FetchUsersInOrgGroup').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.getUserList=data.rObj.userList || [];
              this.userFilteredOptions = this.myPolicyFilters.get('user')?.valueChanges.pipe(
                startWith(''),
                map((value:any) => {
                  const name = typeof value === 'string' ? value : value?.fullName;
                  return name ? this._userFilter(name as string) : this.getUserList.slice();
                }),
              );
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  policyDetailes(quotationID: string, quotesID: string) {
    this.router.navigate(['policy/policy-info', quotationID, quotesID]);
  }

  DownloadPolicy(certificateID: string) {
    let params = {
      certificateID: certificateID
    }
    this.loader.show();
    this.restService.postData(params, 'api/Integration/PrintCertificate').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              if (data.rObj.PrintCertificate.printCertificateResponse.printCertificateResult) {
                window.open(data.rObj.PrintCertificate.printCertificateResponse.printCertificateResult, '_target');
              }

            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  onPageChange(page: number) {
    this.row_count = page;
    this.GetAllMyPolicy();
    window.scrollTo(0, 0);
  }

  Filter() {
    if(this.myPolicyFilters.invalid){
      return;
    }

    this.row_count = 1;
    this.currentPage = 1;
    this.GetAllMyPolicy();
  }

  ClearFilter() {
    this.myPolicyFilters.reset();
    this.page_count = 10;
    this.resultPerpage.patchValue(10);
  }

  FetchConnectedOrganizationsCount() {
    this.loader.show();
    this.restService.postDataDs(null, 'api/digital/core/Entity/FetchConnectedOrganizationsCount').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
             this.connectedOrganizations=data.rObj.connectedOrganizations || [];
             this.filteredOrganizationTypes=this.myPolicyFilters.get('organizationType')?.valueChanges.pipe(
              startWith(''),
                map((value:any) => {
                  const name = typeof value === 'string' ? value : value?.orgGroupRelationshipTypeName;
                  return name ? this._orgTypeFilter(name as string) : this.connectedOrganizations.slice();
                }),
              );
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  FetchConnectedOrganizations(typeCodeNum:number) {
    let params={
      typeCodeNum
  }
    this.loader.show();
    this.restService.postDataDs(params, 'api/digital/core/Entity/FetchConnectedOrganizations').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
             this.organizations=data.rObj.connectedOrganizations || [];
             this.filteredOrganizations=this.myPolicyFilters.get('organization')?.valueChanges.pipe(
              startWith(''),
                map((value:any) => {
                  const name = typeof value === 'string' ? value : value?.orgName;
                  return name ? this._orgFilter(name as string) : this.organizations.slice();
                }),
              );
             
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  onOrgTypeSelected(event: any): void {
    const selectedValue = event.option.value;
    this.FetchConnectedOrganizations(selectedValue.typeCodeNum);
  }

  InsertDownloadReports() {
    let selectedDestination:any = this.myPolicyFilters.get('destination')?.value;
    let selectedOrganization:any = this.myPolicyFilters.get('organization')?.value;
    let params={
        downloadTypeID:200,
        downloadFormatID:1,
        quotationNumber:this.myPolicyFilters.get('policyNumber')?.value?.trim() || null,
        fromDate: this.myPolicyFilters.get('fromDate')?.value ? moment(this.myPolicyFilters.get('fromDate')?.value).format('YYYY-MM-DD') : null,
        toDate: this.myPolicyFilters.get('toDate')?.value ? moment(this.myPolicyFilters.get('toDate')?.value).format('YYYY-MM-DD') : null,
        destinationId:selectedDestination ? selectedDestination?.TocountryID: "00000000-0000-0000-0000-000000000000",
        travelPurposeId:this.myPolicyFilters.get('travelPurpose')?.value || "00000000-0000-0000-0000-000000000000",
        userId:this.userDetail?this.userDetail?.orgGroupID:"00000000-0000-0000-0000-000000000000",
        branchId:selectedOrganization?selectedOrganization?.orgGroupID:"00000000-0000-0000-0000-000000000000",
      }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/InsertDownloadReports').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
           
             
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  getMenuData() {
    this.loader.show();
    this.restService.postDataDs(null, 'api/digital/core/Module/FetchAllModulesforLogedinRole').subscribe(
      {
        next: (data) => {
          try {
            if (data.rcode === 200) {
              this.userDetail = data.rObj.userDetails;
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            console.error(error);
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      }
    );
  }
  redirectToProposalForm(value: any) {
    this.router.navigate(['quotation/proposal-form-edit',value.QuotationID, value.QuotesID]);

  }
}
